import { HttpResponse } from 'buzz_lib_models';

import { HttpGetOptions } from './HttpGetOptions';
import { httpService as createHttpService, HttpService } from './httpService2';

type AuthHttpServiceHeaders = { [key: string]: any };
type AuthHttpServiceBaseUrl = string | undefined;
export class AuthHttpService {
  private authHeaders: AuthHttpServiceHeaders = {};
  private baseUrl: AuthHttpServiceBaseUrl = undefined;
  private httpService: HttpService;

  constructor(baseUrl: AuthHttpServiceBaseUrl, authHeaders: AuthHttpServiceHeaders) {
    this.authHeaders = authHeaders;
    this.baseUrl = baseUrl;
    this.httpService = createHttpService();
  }

  public get = <T>(
    url: string,
    query: { [key: string]: any } = {},
    signal?: AbortSignal,
    headers?: { [key: string]: any },
    options?: HttpGetOptions
  ): Promise<T> => {
    const headersWithAuth = this.getAllHeaders(headers);

    return this.getResponsePromise<T>(() =>
      this.httpService.get(this.getRequestUrl(url), query, signal, headersWithAuth, options)
    );
  };

  public post = <T>(
    url: string,
    body: { [key: string]: any } = {},
    headers: { [key: string]: any } = {}
  ): Promise<T> => {
    const headersWithAuth = this.getAllHeaders(headers);

    return this.getResponsePromise<T>(() => this.httpService.post(this.getRequestUrl(url), body, headersWithAuth));
  };

  public postFile = <T>(url: string, body: FormData, headers: { [key: string]: any } = {}): Promise<T> => {
    const headersWithAuth = this.getAllHeaders(headers);

    return this.getResponsePromise<T>(() => this.httpService.postFile(this.getRequestUrl(url), body, headersWithAuth));
  };

  public put = <T>(url: string, body: { [key: string]: any } = {}, headers?: { [key: string]: any }): Promise<T> => {
    const headersWithAuth = this.getAllHeaders(headers);

    return this.getResponsePromise<T>(() => this.httpService.put(this.getRequestUrl(url), body, headersWithAuth));
  };

  public delete = <T>(url: string, body: { [key: string]: any } = {}, headers?: { [key: string]: any }): Promise<T> => {
    const headersWithAuth = this.getAllHeaders(headers);

    return this.getResponsePromise<T>(() => this.httpService.delete(this.getRequestUrl(url), body, headersWithAuth));
  };

  private getRequestUrl = (path: string) => {
    return this.baseUrl ? `${this.baseUrl}${path}` : path;
  };

  private getAllHeaders = (headers?: { [key: string]: any }) => {
    return {
      ...headers,
      ...this.authHeaders,
    };
  };

  private getResponsePromise = <T = any>(action: () => Promise<HttpResponse | null>) => {
    return new Promise<T>((resolve, reject) => {
      action().then(resp => {
        if (resp?.StatusCode && resp.StatusCode >= 200 && resp.StatusCode < 300) {
          resolve(resp.Body as T);
        } else {
          reject(resp?.Body);
        }
      });
    });
  };
}
